import { ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from '../../styles';

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  :hover {
    ${styles.color.primary};
  }
`;

const Input = styled.input<{ hasChild: boolean }>`
  cursor: pointer;
  ${(props) => (props.hasChild ? styles.mr.md : null)};
`;

export const Checkbox = ({
  checked,
  onChange,
  children,
  disabled,
}: {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  children?: ReactNode;
}) => {
  return (
    <Container
      onClick={() => {
        if (disabled) {
          return;
        }

        if (typeof onChange === 'function') {
          onChange(!checked);
        }
      }}
    >
      <Input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        hasChild={Boolean(children)}
        onChange={(e) => {
          e.stopPropagation();

          if (disabled) {
            return;
          }
          if (typeof onChange === 'function') {
            onChange(e.target.checked);
          }
        }}
      />
      {children}
    </Container>
  );
};
